import { render, staticRenderFns } from "./Sponsorer.vue?vue&type=template&id=1870c848&scoped=true&"
import script from "./Sponsorer.vue?vue&type=script&lang=js&"
export * from "./Sponsorer.vue?vue&type=script&lang=js&"
import style0 from "./Sponsorer.vue?vue&type=style&index=0&id=1870c848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1870c848",
  null
  
)

export default component.exports